<main #main>
    <!-- Header -->
    <np-header *ngIf="!hideHeaderFooter">
        <div *ngIf="!isProd" class="row environment environment_reg">
            <img src="../assets/images/working.png" class="environment_img"/>
            <h4 class="environment_title" style="margin: auto;">{{setEnvironmentName()}} ENVIRONMENT</h4>
        </div>
    </np-header>

    <div *ngIf="hideHeaderFooter" class="environment_embed">
        <div *ngIf="!isProd" class="row environment">
            <img src="../assets/images/working.png" class="environment_img"/>
            <h4 class="environment_title" style="margin: auto;">{{setEnvironmentName()}} ENVIRONMENT</h4>
        </div>
    </div>

    <!-- Site-Specific Navigation -->
    <app-main-top-menu [navItems]="NP.options.navigationItems"></app-main-top-menu>

    <!-- Main Content -->
    <router-outlet></router-outlet>

    <!-- Footer -->
    <np-footer
        *ngIf="!hideHeaderFooter"
        [contentContactName]="'CTC - Fixed Equipment Engineering'"
        [contentContactUrl]="'mailto:AlfonsoRamos@chevron.com'"
        [technicalContactName]="'Ticket Request'"
        [technicalContactUrl]="'https://go.chevron.com/appsupport'"
        [opcoName]="'Technical Center'"
        [opcoUrl]="'https://inside.chevron.com/organization-operations/technology'">
    </np-footer>
</main>
